import type { Observable } from 'rxjs';

import { ApiQuery } from '@apps/main/modules/api/shared/apiQuery';
import { camelCased } from '@apps/main/modules/api/shared/apiQuery.helper';

import type { SemboUser } from '../../models/semboUser';

export class UserService {
  private apiQuery = new ApiQuery();

  public fetchSemboUser(): Observable<SemboUser> {
    const url = 'mvc/Members/GetMember';
    return this.apiQuery
      .getObservable<SemboUser>(url)
      .pipe(camelCased({ deep: true }));
  }
}
